import { render, staticRenderFns } from "./IconDeleteUpload.vue?vue&type=template&id=03af71c0&scoped=true"
import script from "./IconDeleteUpload.vue?vue&type=script&lang=js"
export * from "./IconDeleteUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03af71c0",
  null
  
)

export default component.exports